import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface CapacityAlertFilters {
  status?: "active" | "resolved" | "all";
  store_id?: string;
  page?: number;
  limit?: number;
}

export const useGetCapacityAlerts = (
  filters: CapacityAlertFilters = {},
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>([ENDPOINTS.CAPACITY_ALERTS, filters], {
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};
